import { useMutation, useQuery } from '@apollo/client'
import { AuthContext } from '@deltek/specification-client/core/Configurations/AuthContext'
import { InsertCurrentUserInfoMutation } from '@deltek/specification-client/core/GraphQL/Mutations/currentUserInfo.mutations'
import { CurrentUserInfoQuery } from '@deltek/specification-client/core/GraphQL/Queries/currentUserInfo.queries'
import { CurrentUserInfoResponse } from '@deltek/specification-client/core/Models/currentUserInfo'
import React, { useContext, useEffect, useRef } from 'react'
import AuthEventService from 'shared/services/authEventService'

/**
 * Manages user session lifecycle and emits auth events.
 * Detects login/logout for cache invalidation.
 */
const CurrentUserConfiguration: React.FC = ({ children }) => {
    const { currentUserInfo } = useContext(AuthContext)
    const previousUserInfo = useRef(currentUserInfo)
    const { data: currentUserInfoResponse } = useQuery<CurrentUserInfoResponse>(
        CurrentUserInfoQuery
    )
    const [insertCurrentUserInfo] = useMutation<CurrentUserInfoResponse>(
        InsertCurrentUserInfoMutation
    )

    useEffect(() => {
        // Initialize user info on login
        if (currentUserInfo && !currentUserInfoResponse) {
            insertCurrentUserInfo({
                variables: {
                    currentUserInfo,
                },
            })
        }

        // Emit auth events for login/logout
        if (previousUserInfo.current && !currentUserInfo) {
            AuthEventService.emitLogout()
        } else if (!previousUserInfo.current && currentUserInfo) {
            AuthEventService.emitLogin()
        }

        previousUserInfo.current = currentUserInfo
    }, [
        currentUserInfo,
        currentUserInfoResponse,
        insertCurrentUserInfo,
    ])

    return <>{children}</>
}

export default CurrentUserConfiguration